var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', {
    staticClass: "expert-modify-wrapper"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h2', {
    staticClass: "join-title"
  }, [_vm._v("전자제조지원단 전문가 정보변경")]), _c('nav', {
    staticClass: "join-step",
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_c('ul', {
    staticClass: "join-step-lists"
  }, [_c('li', {
    class: 'list' + (_vm.isLogin ? ' list--on' : '')
  }, [_c('span', {
    staticClass: "badge"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "text"
  }, [_vm._v("로그인")])]), _c('li', {
    class: 'list' + (_vm.isLogin ? '' : ' list--on')
  }, [_c('span', {
    staticClass: "badge"
  }, [_vm._v("2")]), _c('span', {
    staticClass: "text"
  }, [_vm._v("정보입력")])])])]), _c('div', {
    staticClass: "expert-modify-inner-wrapper"
  }, [_vm._t("default")], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }